import React, { useEffect } from 'react';
import { Button, Form, Image, Modal } from 'semantic-ui-react';
import { TextField } from '../../common/FormFields';
import { connect } from 'react-redux';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import { repInitialValues, repValidationSchema } from '../adslot.constants';
import FirmDropDown from '../FirmDropDown';
import CloudinaryUploadWidget from '../CloudinaryUploadWidget';

const AddRepModal = ({ preloadShowcaseData, addRepresentative, firm, getFirms }) => {
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    getFirms();
  }, []);

  const handleSubmit = (rep, formik) => {
    addRepresentative(rep);
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Formik
      initialValues={{ ...repInitialValues, showcaseFirmId: firm.id }}
      enableReinitialize
      validationSchema={repValidationSchema}
      onSubmit={handleSubmit}
    >
      {formik => (
        <Modal
          size="small"
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          open={open}
          trigger={<Button icon="plus" labelPosition="left" positive content="Realtor" />}
        >
          <Modal.Header>Create realtor</Modal.Header>
          <Modal.Content scrolling>
            <Form onSubmit={formik.handleSubmit} widths="equal">
              <Form.Group>
                <FirmDropDown
                  id="showcaseFirmId"
                  name="showcaseFirmId"
                  label="Firm"
                  formik={formik}
                  value={formik.values.showcaseFirmId}
                  onChange={formik.handleChange}
                  error={formik.touched.showcaseFirmId && Boolean(formik.errors.showcaseFirmId)}
                  errorMessage={formik.errors.showcaseFirmId}
                />
              </Form.Group>

              <Form.Group>
                <TextField
                  name="name"
                  formik={formik}
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  errorMessage={formik.errors.name}
                  label="Name"
                />
              </Form.Group>

              <Form.Group>
                <TextField
                  name="email"
                  formik={formik}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  errorMessage={formik.errors.email}
                  label="Email"
                />
              </Form.Group>

              <Form.Group>
                <TextField
                  name="phone"
                  formik={formik}
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  error={formik.touched.phone && Boolean(formik.errors.phone)}
                  errorMessage={formik.errors.phone}
                  label="Phone"
                />
              </Form.Group>

              {formik.values.imageUrl && <Image src={formik.values.imageUrl} size="small" />}
              <Form.Group>
                <Form.Field width="4" style={{ paddingTop: 20 }}>
                  <CloudinaryUploadWidget formik={formik} fieldName={'imageUrl'} label="Upload realtor photo" />
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button content="Save" labelPosition="left" icon="save" onClick={formik.handleSubmit} positive />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  firm: selectors.getCurrentFirm(state),
});

const mapDispatchToProps = dispatch => ({
  preloadShowcaseData: bindActionCreators(actions.showcase.preloadShowcaseData, dispatch),
  addRepresentative: bindActionCreators(actions.rep.addRep, dispatch),
  getFirms: bindActionCreators(actions.firm.getFirms, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddRepModal);
